import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { OperationService } from "../../services/operations/operation.service";
import { Subscription } from "rxjs";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HelpService } from "../../services/help.service";
import xmlFormat from 'xml-formatter';
import { LoadActivityModel } from "../../models/warehouse-edi/load-activity.model";

@Component({
    selector: 'app-edi-file-dialog',
    templateUrl: './edi-file-dialog.component.html',
    styleUrls: ['./edi-file-dialog.component.scss'],
    standalone: false
})
export class EdiFileDialogComponent implements OnInit, OnDestroy {

  xmlEdiFile: string = '';
  xmlEdiFileSubs: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LoadActivityModel,
    private readonly operationService: OperationService,
    private readonly helpService: HelpService,
  ) { }

  ngOnInit(): void {
    this.getXmlEdiFile(this.data.activityId);
  }

  ngOnDestroy(): void {
    if (this.xmlEdiFileSubs) {
      this.xmlEdiFileSubs.unsubscribe();
    }
  }

  private getXmlEdiFile(activityId: number) {
   this.xmlEdiFileSubs = this.operationService.getXmlEdiFile(activityId).subscribe({
    next: (response) => {
      this.xmlEdiFile = xmlFormat(response, {
        indentation: '  ',
        collapseContent: true,
        lineSeparator: '\n'
      });
    },
    error: () => this.helpService.showMessageNotification('Error! Please try again', 'danger')
   });
  }

}

